var _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeniusWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "256px",
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: "70%",
    fontFamily: "Arial",
    fontSize: 150,
    fill: "green",
    textAnchor: "middle",
    alignmentBaseline: "central"
  }, "GW")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeniusWeb);
export default __webpack_public_path__ + "static/media/geniusWeb.f2e59d88e7b36d106093a7e4de72843f.svg";
export { ForwardRef as ReactComponent };